webpackJsonp([1],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postVisitedGSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMetaByKeyword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * Created by Joe on 2017/7/19.
 */


var base = 'http://api.gushuhua.org';

var postKeyword = function postKeyword(keyword) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/queryKeyword/keyword/' + keyword).then(function (res) {
    return res.data;
  });
};

var postVisitedGSH = function postVisitedGSH(md5, name, author) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(base + '/v1/visitedGSH/md5/' + md5 + '/name/' + name + '/author/' + author).then(function (res) {
    return res.data;
  });
};

var getMetaByKeyword = function getMetaByKeyword(keyword) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(base + '/v1/GSH?keyword=' + keyword).then(function (res) {
    return res.data;
  });
};

/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// import Z from './assets/ZoomifyImageViewerPro-src'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

// 百度统计
var _hmt = _hmt || [];
(function () {
  var hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?c7dc84ac3121d0da8959997251143e55';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})();

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-waterfall-easy',
  props: {
    gap: {
      type: Number,
      default: 20
    },
    imgsArr: {
      type: Array,
      required: true
    },
    imgWidth: {
      type: Number,
      default: 240
    },
    timeOut: {
      type: Number,
      default: 500
    }
  },
  data: function data() {
    return {
      msg: 'this is from vue-waterfall-easy.vue',
      colsHeightArr: [],
      imgBoxEls: null,
      columnCount: NaN,
      isMobile: false,
      beginIndex: NaN,
      isPreloading: true,
      isPreloadingC: true,
      imgsArrC: [],
      loadedCount: 0,
      isFirstTIme: true };
  },

  computed: {
    boxWidth: function boxWidth() {
      return this.imgWidth + this.gap;
    },
    imgWidthC: function imgWidthC() {
      return this.isMobile ? window.innerWidth / 2 - this.gap : this.imgWidth;
    }
  },
  methods: {
    waterfall: function waterfall() {
      for (var i = this.beginIndex; i < this.imgsArr.length; i++) {
        var minHeight = Math.min.apply(null, this.colsHeightArr);
        var minIndex = this.colsHeightArr.indexOf(minHeight);
        var width = this.imgBoxEls[0].offsetWidth;
        this.imgBoxEls[i].style.position = 'absolute';
        this.imgBoxEls[i].style.left = minIndex * width + 'px';
        this.imgBoxEls[i].style.top = minHeight + 'px';

        this.$set(this.colsHeightArr, minIndex, minHeight + this.imgBoxEls[i].offsetHeight);
      }
      this.beginIndex = this.imgsArr.length;
    },
    loadFn: function loadFn(e, oImg, i) {
      var _this = this;

      this.loadedCount++;
      if (e.type === 'load') {
        this.$set(this.imgsArr[i], 'height', Math.round(this.imgWidthC / (oImg.width / oImg.height)));
      }
      if (this.loadedCount === this.imgsArr.length) {
        this.imgsArrC = this.imgsArr.concat([]);

        this.isPreloading = false;
        this.isFirstTIme = false;

        this.$nextTick(function () {
          _this.initImgBoxEls();
          _this.$emit('preloaded');
        });
      }
    },
    preload: function preload() {
      var _this2 = this;

      this.imgsArr.forEach(function (v, i) {
        if (i < _this2.loadedCount) return;
        var oImg = new Image();
        oImg.addEventListener('load', function (e) {
          _this2.loadFn(e, oImg, i);
        });
        oImg.src = v.src;
      });
    },
    initColsHeightArr: function initColsHeightArr() {
      this.colsHeightArr = [];
      for (var i = 0; i < this.columnCount; i++) {
        this.imgBoxEls[i].style.position = 'static';
        var height = this.imgBoxEls[i].offsetHeight;
        this.colsHeightArr.push(height);
      }
    },
    initImgBoxEls: function initImgBoxEls() {
      this.imgBoxEls = document.getElementsByClassName('img-box');
    },
    initIsMobile: function initIsMobile() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) this.isMobile = true;
    },
    initColumnCount: function initColumnCount() {
      var winWidth = window.innerWidth;
      if (winWidth > this.boxWidth * 5) {
        this.columnCount = 5;
      } else if (winWidth > this.boxWidth * 4) {
        this.columnCount = 4;
      } else if (winWidth > this.boxWidth * 3) {
        this.columnCount = 3;
      } else if (winWidth > this.boxWidth * 2) {
        this.columnCount = 2;
      } else {
        this.columnCount = this.isMobile ? 2 : 1;
      }
      this.beginIndex = this.columnCount;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.initIsMobile();
    this.initColumnCount();

    this.preload();

    this.$on('preloaded', function () {
      if (_this3.colsHeightArr.length === 0) _this3.initColsHeightArr();
      _this3.waterfall();
    });

    window.addEventListener('resize', function () {
      _this3.initColumnCount();
      _this3.initColsHeightArr();
      _this3.waterfall();
    });

    window.addEventListener('scroll', function () {
      if (_this3.isPreloading) return;
      if (document.body.scrollTop + window.innerHeight > document.body.scrollHeight - 30) {
        _this3.$emit('scrollLoadImg');
      }
    });
  },

  watch: {
    imgsArr: function imgsArr(newV, oldV) {
      if (newV.length === oldV.length) return;
      this.isPreloading = true;
      this.preload();
    },
    isPreloading: function isPreloading(v) {
      var _this4 = this;

      if (v) {
        setTimeout(function () {
          if (!_this4.isPreloading) return;
          _this4.isPreloadingC = true;
        }, 500);
      } else {
        this.isPreloadingC = false;
      }
    }
  }
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

//  import { Loading } from 'element-ui';
//  import Z from './assets/ZoomifyImageViewerPro-src'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'canvas-gsh',
  props: ['md5'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    /* global Z */
    Z.showImage('myContainer', 'http://zif.gushuhua.org/' + this.$route.params.md5 + '.zif', 'zInitialFullPage=1&zFullPageVisible=1&zNavigatorVisible=0&zToolbarVisible=0');
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_index__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('gsh-item-zh', {
  functional: true,
  render: function render(h, ctx) {
    var item = ctx.props.item;
    for (var key in item) {
      if (item[key] == null) {
        item[key] = '';
      }
    }
    return h('li', ctx.data, [h('div', { attrs: { class: 'name' } }, [item.value]), h('span', { attrs: { class: 'sub-title' } }, [item.dynasty + ' ' + item.author + ' ' + item.material + ' ' + item.form + ' ' + item.museum])]);
  },
  props: {
    item: { type: Object, required: true }
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      state: ''
    };
  },

  methods: {
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var _this = this;

      if (queryString !== '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_index__["a" /* getMetaByKeyword */])(queryString).then(function (value) {
          var searchList = value.result.filter(function (e, i, a) {
            // 关键字查找并过滤重复作品
            return (e.name.indexOf(queryString) !== -1 || e.author.indexOf(queryString) !== -1) && __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(a, function (o) {
              return o.name === e.name && o.author === e.author;
            }) === i;
          });
          _this.$store.commit('setSearchList', searchList);
          searchList = searchList.map(function (e) {
            return {
              value: e.name,
              author: e.author,
              md5: e.md5,
              dynasty: e.dynasty,
              form: e.form,
              material: e.material,
              museum: e.museum,
              width: e.width,
              height: e.height
            };
          });
          cb(searchList);
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_index__["b" /* postKeyword */])(queryString);
      } else {
        cb([]);
      }
    },
    handleSelect: function handleSelect(item) {
      this.$router.push({ name: 'canvas-gsh', params: { md5: item.md5 } });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_index__["c" /* postVisitedGSH */])(item.md5, item.value, item.author);
    },
    handleIconClick: function handleIconClick(ev) {
      var queryString = this.state;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_index__["b" /* postKeyword */])(queryString);
      this.$router.push({ name: 'waterfall' });
    }
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_waterfall_easy__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_waterfall_easy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_waterfall_easy__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      j: 0,
      filterResLen: 0,
      imgsArr: [],
      fetchImgsArr: [],
      md5List: [],
      descList: []
    };
  },

  components: {
    vueWaterfallEasy: __WEBPACK_IMPORTED_MODULE_0_vue_waterfall_easy___default.a
  },
  methods: {
    initImgsArr: function initImgsArr(n, m) {
      // console.log('j:', this.j)
      this.j++;
      var arr = [];
      for (var i = n; i < m && i < this.filterResLen; i++) {
        arr.push({
          src: 'http://thumb.gushuhua.org/' + this.md5List[i] + '.jpg',
          info: this.descList[i],
          md5: this.md5List[i]
        });
      }
      return arr;
    },
    fetchImgsData: function fetchImgsData() {
      this.imgsArr = this.imgsArr.concat(this.initImgsArr(20 * (this.j - 1), 20 * this.j));
    }
  },
  mounted: function mounted() {
    var searchList = this.$store.getters.searchList;
    // console.log('searchList:', searchList)
    this.filterResLen = searchList.length;
    // console.log('len:', this.filterResLen)
    this.md5List = searchList.map(function (e) {
      return e.md5;
    });
    this.descList = searchList.map(function (e) {
      return '【' + e.dynasty + ' ' + e.author + ' ' + e.name + '】';
    });
    this.imgsArr = this.initImgsArr(0, 20);
    this.fetchImgsArr = this.initImgsArr(20 * (this.j - 1), 20 * this.j);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.9f94efc.png";

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(189),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(192),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(191),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(190),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 189:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myContainer"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-waterfall-easy",
    style: (_vm.isMobile ? '' : {
      width: _vm.boxWidth * _vm.columnCount + 'px',
      left: '50%',
      marginLeft: -1 * _vm.boxWidth * _vm.columnCount / 2 + 'px'
    })
  }, [_vm._l((_vm.imgsArrC), function(v, i) {
    return _c('div', {
      staticClass: "img-box",
      style: ({
        padding: _vm.gap / 2 + 'px',
        width: _vm.isMobile ? '' : _vm.boxWidth + 'px'
      })
    }, [_c('div', {
      staticClass: "img-inner-box"
    }, [_c('div', {
      staticClass: "img-wraper",
      style: ({
        width: _vm.imgWidthC + 'px',
        height: v.height ? v.height + 'px' : ''
      })
    }, [_c('img', {
      attrs: {
        "src": v.src
      }
    })]), _c('div', {
      staticClass: "img-info"
    }, [_vm._t("default", null, {
      "index": i,
      "value": v
    })], 2)])])
  }), (_vm.isPreloadingC) ? _c('div', {
    staticClass: "loading",
    class: {
      'first-loading': _vm.isFirstTIme
    }
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _c('div', {
    staticClass: "double-bounce2"
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-waterfall-easy', {
    attrs: {
      "imgsArr": _vm.imgsArr
    },
    on: {
      "scrollLoadImg": _vm.fetchImgsData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'canvas-gsh',
              params: {
                md5: props.value.md5
              }
            }
          }
        }, [_c('p', {
          staticClass: "some-info"
        }, [_vm._v(_vm._s(props.value.info))])])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": __webpack_require__(184),
      "id": "logo"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-autocomplete', {
    attrs: {
      "popper-class": "gsh-autocomplete",
      "fetch-suggestions": _vm.querySearchAsync,
      "custom-item": "gsh-item-zh",
      "placeholder": "作品名称或作者姓名",
      "size": "large",
      "icon": "search",
      "on-icon-click": _vm.handleIconClick
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state),
      callback: function($$v) {
        _vm.state = $$v
      },
      expression: "state"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Canvas__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Waterfall__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Waterfall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Waterfall__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Search___default.a
  }, {
    path: '/canvas-gsh/:md5',
    name: 'canvas-gsh',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Canvas___default.a
  }, {
    path: '/waterfall/',
    name: 'waterfall',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Waterfall___default.a
  }]
}));

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(196);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    searchList: null
  },
  mutations: {
    setSearchList: function setSearchList(state, searchList) {
      state.searchList = searchList;
    }
  },
  getters: {
    searchList: function searchList(state) {
      return state.searchList;
    }
  }
});

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[119]);


// WEBPACK FOOTER //
// static/js/app.e5d850fb30515698aac5.js